import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base'

@Component({
  selector: 'app-boolean-label',
  templateUrl: './boolean-label.component.html',
  styleUrls: ['./boolean-label.component.scss']
})
export class BooleanLabelComponent extends ComponentBase implements OnInit {

  valueChange: boolean = true;

  constructor() { super() }

  ngOnInit() {
    this.valueChange = this.attribute.value!=null?true:false;
  }

  onValueChange(value: boolean) {
    this.valueChange = value;
    this.attribute.value = null;
  }
}
